import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { API_BASE_URL, UPLOADS_URL } from "../config";
import VideoSidebar from "../components/VideoSidebar";
import "../styles/TikTokFeed.css";

// Cette ligne permet de savoir si on est sur le navigateur ou dans l'app mobile
const isWeb = typeof window !== 'undefined' && !window.ReactNativeWebView;

export default function TikTokFeed() {
  const [videos, setVideos] = useState([]);
  const playerRefs = useRef([]);

  useEffect(() => {
    axios.get(`${API_BASE_URL}/videos`)
      .then((res) => setVideos(res.data))
      .catch((err) => console.error("Erreur API :", err));
  }, []);

  return (
    <div className="tiktok-feed">
      {videos.map((video, index) => {
        // On utilise ici ton URL de base pour tes vidéos
        const videoUrl = `${UPLOADS_URL}/${video.file_path?.replace(/\\/g, "/").replace(/^uploads\//i, "")}`;

        return (
          <div key={video.id || index} className="tiktok-video" ref={(el) => (playerRefs.current[index] = el)}>
            
            {/* Si on est sur le WEB, on utilise la balise standard */}
            <video
              className="tiktok-player"
              src={videoUrl}
              loop
              playsInline
              muted
              autoPlay
              style={{ width: '100%', height: '100%', objectFit: 'cover', backgroundColor: 'black' }}
            />

            <div className="creator-info">
              <p className="creator-pseudo">@{video.user_pseudo}</p>
            </div>
            <VideoSidebar video={video} />
          </div>
        );
      })}
    </div>
  );
}